module.exports = __webpack_public_path__ + "h5/img/logo.5f745045.png";